import { useSignInOnce } from 'api/auth/MiniAppAuth';
import { Hero } from './Hero/Hero';
import { Upcoming } from './upcoming/Upcoming';
export const ConcertsPage = () => {
  useSignInOnce();
  return (
    <>
      <Hero />
      <Upcoming />
    </>
  );
};
